import type { AccessManifest } from "@/auth/AccessManifestProvider";
import { CONTEXT_MESH_CAPABILITIES, hasManifestCapability } from "@/auth/accessNavigation";

interface ProductCreationRoutingOptions {
    manifest: AccessManifest | null;
    asyncProductCreationEnabled: boolean;
    productsDashboardV2Enabled: boolean;
    hasAuthenticatedUser: boolean;
}

/**
 * Context Mesh-only creation must use the entitlement-aware durable workflow.
 * Product Studio customers continue to follow the existing feature-flag rollout.
 */
export function shouldUseDurableProductCreation({
    manifest,
    asyncProductCreationEnabled,
    productsDashboardV2Enabled,
    hasAuthenticatedUser
}: ProductCreationRoutingOptions): boolean {
    if (!productsDashboardV2Enabled || !hasAuthenticatedUser) return false;

    const requiresContextMeshCreationMode = Boolean(
        manifest?.entitlements.context_mesh &&
        !manifest.entitlements.product_studio &&
        hasManifestCapability(manifest, CONTEXT_MESH_CAPABILITIES.createProduct)
    );

    return asyncProductCreationEnabled || requiresContextMeshCreationMode;
}
